<template>

  <tr :class="{'box-loading': loading}">
    <td class="text-truncate">
      {{ [value.device.client_name, value.device.os_name].join(', ') }}
      <span class="badge badge-pill badge-success" v-if="value.is_current">{{ $t('This device') }}</span>
    </td>
    <td class="text-truncate">{{ value.ip }}</td>
    <td class="text-truncate">
      <span v-if="value.last_access">{{ value.last_access | moment('fromNow', $i18n.locale) }}</span>
    </td>
    <td class="text-truncate">
      <span v-if="value.expired_at">{{ $d(new Date(value.expired_at), 'short') }}</span>
    </td>
    <td class="text-truncate">
      {{ $d(new Date(value.created_at), 'short') }}
    </td>
    <td class="text-truncate">
      <a
        href="javascript:void(0)"
        @click="deleteSession(value._id)">{{ $t('Disconnect') }}</a>
    </td>
  </tr>

</template>

<script>
export default {
  name: 'Source',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    delete
    */
    deleteSession (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteSession', id)
        .then((result) => {
          this.loading = false
          this.$emit('removed')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Session/SessionItem.vue